const KEY_ENABLED = 'sound_enabled';
const KEY_VOLUME  = 'sound_effects_volume';
const DEFAULT_VOLUME = 0.7;

function readBool(key: string, fallback: boolean): boolean {
  const raw = localStorage.getItem(key);
  return raw === null ? fallback : raw !== 'false';
}

function readFloat(key: string, fallback: number): number {
  const raw = localStorage.getItem(key);
  if (raw === null) return fallback;
  const n = parseFloat(raw);
  return isNaN(n) ? fallback : Math.max(0, Math.min(1, n));
}

export const SoundSettings = {
  getSoundEnabled(): boolean {
    return readBool(KEY_ENABLED, true);
  },
  setSoundEnabled(value: boolean): void {
    localStorage.setItem(KEY_ENABLED, String(value));
  },
  getEffectsVolume(): number {
    return readFloat(KEY_VOLUME, DEFAULT_VOLUME);
  },
  setEffectsVolume(value: number): void {
    localStorage.setItem(KEY_VOLUME, String(Math.max(0, Math.min(1, value))));
  },
};
